import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { baseApi } from "redux_dir/features/apiMananger";
import { paiementApi } from "redux_dir/features/paiementApi";
import diagnostiqueReducer from "redux_dir/features/diagnostiqueSlice";
import parentReducer from "redux_dir/features/parentSlice";
import userReducer from "redux_dir/features/userSlice";
import eleveReducer from "redux_dir/features/eleveSlice";
import newOnboardingReducer from "redux_dir/features/newOnboardingSlice";

const persistConfig = {
  key: "root-genimi-parent-v3",
  storage,
};

// `newOnboarding` doit avoir sa PROPRE clé de stockage. Avec la même clé que
// `user`, les deux persistReducer écrivaient dans `persist:root-genimi-parent-v3`
// et s'écrasaient mutuellement : le token JWT et l'id du parent pouvaient
// disparaître après un rechargement (d'où "Impossible de charger le profil").
const onboardingPersistConfig = {
  key: "root-genimi-onboarding-v1",
  storage,
};

const rootReducer = combineReducers({
  user: persistReducer(
    persistConfig,
    combineReducers({
      userReducer,
      diagnostiqueReducer,
      parentReducer,
      eleveReducer,
    })
  ),
  newOnboarding: persistReducer(
    onboardingPersistConfig,
    newOnboardingReducer
  ),
  // diagnostique: persistReducer(persistConfig, diagnostiqueReducer),
  [baseApi.reducerPath]: baseApi.reducer,
  [paiementApi.reducerPath]: paiementApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat([baseApi.middleware, paiementApi.middleware]);
  },
  devTools: true,
});

export const persistor = persistStore(store);
